// extracted by mini-css-extract-plugin
export default {"graph":"Table_graph__fkBiJ","table":"Table_table__0XUGw","modal":"Table_modal__WDFEr","paper":"Table_paper__Mg3tD"};